import React, { useState,useEffect } from 'react';
import { Button, Card, CardBody, Col, Container, Row,Spinner, Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { BasicTable } from './datatableCom';
import { Link  } from 'react-router-dom';
import classnames from "classnames";
import axios from "axios";
import {  BACKEND_Externe_URL, BACKEND_URL_PORTAIL} from "../../../config/const.js";
import { useTranslation } from 'react-i18next';
import MultiDeleteDialog from './MultiDeleteDialog';

const ListUsers = () => {
    const [customActiveTab, setcustomActiveTab] = useState("1");
    const [searchTerm, setSearchTerm] = useState('');
    const [users,setUsers] = useState([]);
    const [selectedUserIds, setSelectedUserIds] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [open2faUsers, setOpen2faUsers] = useState(false);
    const [openNoUserSelected, setOpenNoUserSelected] = useState(false);
    const [value, setValue] = useState("true");
    const {t} = useTranslation();
    document.title= t('usersManagement') +" | "+ t('quessCompounding') 



    const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      
      const fetchUserProfile = async () => {
        const data={
            groupId:localStorage.getItem("currentOrg")
        }
      try {
        const response = await axios.post(`${BACKEND_URL_PORTAIL}api/isAdmin`,{currentOrg:localStorage.getItem("currentOrg")},  config);
       switch (response) {
        case "BCEAdmin":
            var responseUsers = await axios.get(`${BACKEND_URL_PORTAIL}api/getAllUsersData`,  config);
            setUsers(responseUsers);
        break;

        case "admin": 
            var responseUsers = await axios.post(`${BACKEND_URL_PORTAIL}api/getGroupUsers`,data,  config);
            setUsers(responseUsers)
        break;
       }
        
     
      } catch (error) {
        console.error("Error fetching profile data:", error.response ? error.response : error.message);
      
      }finally {
        setLoading(false); 
    }
    };
    useEffect(() => {
        
    
        fetchUserProfile();
      }, []); 
    const handleOpenDialog = () => {
        setIsDialogOpen(true);
      };
    
      const handleCloseDialog = () => {
        setIsDialogOpen(false);
      };

    const handleClickOpen2faUsers = () => {
        if(selectedUserIds.length){
          setOpen2faUsers(true);
        } else {
          setOpenNoUserSelected(true);
        }
      };

    const handleClose2faUsers = () => {
        setOpen2faUsers(false);
    };
    const handleChange = (event) => {
  setValue(event.target.value);
};

function update2FAUsers() {
        const config = {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
        };
        const data={
          listUsersId : selectedUserIds,
          hasDoubleAuth : value=="true"?true:false
          }
         
        axios.post(BACKEND_URL_PORTAIL + 'api/update2FAListUsers', data , config).then((response) => {
          window.location.reload();
        });
      }
       const handleCloseNoUserSelected = () => {
   
    setOpenNoUserSelected(false);
  };
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Card className="card-bordred custom-card">
 <Breadcrumbs title={t('usersManagement')} breadcrumbItem={t('listOfUsers')} />

                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <div id="customerList">
                                        <Row className="g-4 mb-3">
                                            <Col className="col-sm-auto">
                                                <div className="d-flex gap-1">
                                                    <Button
                                                        color="primary"
                                                        className="add-btn"
                                                        tag={Link}
                                                        to="/create-user"
                                                        id="create-btn"
                                                        
                                                    >
                                                        <i className="ri-add-line align-bottom me-1"></i>
                                                       {t('createUser')}
                                                    </Button>
                                                    {selectedUserIds.length === users.length ? (
                                                        <Button color="primary" onClick={() => setSelectedUserIds([])}>
                                                             {t('allDeselect')}
                                                        </Button>
                                                            ) : (
                                                        <Button color="primary" onClick={() => setSelectedUserIds(users.map(u => u.idUser))}>
                                                             {t('allSelect')}
                                                        </Button>
                                                         )}

                                                        <Button color="primary" onClick={() => handleClickOpen2faUsers()}>
                                                             {t('Add2fa')}
                                                        </Button>
                                                        <Button color="danger" onClick={handleOpenDialog} disabled={setSelectedUserIds.length === 0} >
                                                            {t('delete')}
                                                        </Button>
                                                </div>
                                            </Col>
                                            <Col className="col-sm">
                                                <div className="d-flex justify-content-sm-end">
                                                    <div className="search-box">
                                                        <input
                                                            type="text"
                                                            className="form-control search"
                                                            placeholder={t('search')}
                                                            value={searchTerm}
                                                            onChange={e => setSearchTerm(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Col lg={12}>
                                            {loading ? (
                                                <div className="text-center mt-6">
                                                            <Spinner
                                                           color="primary"
                                                           style={{
                                                             height: '3rem',
                                                             width: '3rem'
                                                           }}
                                                         >
                                                           Loading...
                                                            </Spinner>
                                                            <div className="text-center mt-2">
                                                          {t("loading...")}
                                                          </div>
                                                          </div>
                                            ) : (
                                                <Row>
                                                    <Col sm="12">
                                                        <div>
                                                            <BasicTable searchTerm={searchTerm} 
                                                             initialData={users}
                                                             fetchUserProfile={fetchUserProfile} 
                                                             source="listUsers" 
                                                             onSelectionChange={setSelectedUserIds} 
                                                             selectedUserIds={selectedUserIds}/>
                                                             
                                                        </div>
                                                    </Col>
                                                </Row>
                                            )}
                                        </Col>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    </Card>
                   
                </Container>
                {isDialogOpen && (
                        <MultiDeleteDialog
                        isOpen={isDialogOpen}
                        handleClose={handleCloseDialog}
                        listUsers={selectedUserIds} // Pass groupId to the dialog
                        fetchUserProfile={fetchUserProfile}
                        />
                    )}

                <Modal isOpen={open2faUsers} toggle={() => setOpen2faUsers(!open2faUsers)} centered >
                    <ModalHeader  className="detail-header">
                        {t('2faUsers')}
                    </ModalHeader>

                    <ModalBody>
                        <div className="container">
                        <div className="row">
                            <div className="col-md-3 col-3"></div>
                            <div className="col-md-3 col-3">
                                <fieldset className="form-group">
                                    
                                    <div className="form-check radioBoxMargin">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="2faOption"
                                        id="2faEnable"
                                        value="true"
                                        checked={value === 'true'}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="2faEnable">
                                        {t('activer')}
                                    </label>
                                    </div>
                                </fieldset>
                                
                            </div>
                            <div className="col-md-3 col-3">
                                <fieldset className="form-group">

                                    <div className="form-check radioBoxMargin">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="2faOption"
                                        id="2faDisable"
                                        value="false"
                                        checked={value === 'false'}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="2faDisable">
                                        {t('desactiver')}
                                    </label>
                                    </div>
                                </fieldset>
                            </div>
                            

                        </div>
                        </div>
                    </ModalBody>

                    <ModalFooter>
                        <button className="btn btn-secondary" onClick={handleClose2faUsers}>
                        {t('cancel')}
                        </button>
                        <button className="btn btn-primary" onClick={() => { update2FAUsers(); handleClose2faUsers(); }}>
                        {t('UPDATE')}
                        </button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={openNoUserSelected} toggle={handleCloseNoUserSelected} centered>
                    <ModalBody className="text-center">
                        <div className="fileDesc mb-3">
                        <div className="d-flex justify-content-center align-items-center">
                            <i className="mdi mdi-alert-circle mdi-48px text-danger"></i>
                        </div>
                        </div>
                        <p className="alertMsg">
                        {t('NoUserSelected')}
                        </p>
                    </ModalBody>

                    <ModalFooter className="d-flex justify-content-center">
                        <button className="btn btn-primary" onClick={handleCloseNoUserSelected}>
                        {t('Ok')}
                        </button>
                    </ModalFooter>
                </Modal>


   
            </div>
        </React.Fragment>
    );
};

export default ListUsers;
